import { createRouter, createWebHashHistory } from 'vue-router';
// 注册路由组件
const Home = () => import('@/views/Home.vue');
const Channel = () => import('@/views/Channel.vue');
const childChannel = () => import('@/views/childChannel.vue');
const Topic = () => import('@/views/Topic.vue');
const Topic2 = () => import('@/views/Topic2.vue');
const LiveDetail = () => import('@/views/detail/LiveDetail.vue');
const VideoDetail = () => import('@/views/detail/VideoDetail.vue');
const TextDetail = () => import('@/views/detail/TextDetail.vue');
const ImageDetail = () => import('@/views/detail/ImageDetail.vue');
const TopicDetail = () => import('@/views/detail/TopicDetail.vue');
const GroupDetail = () => import('@/views/detail/GroupDetail.vue');
const AudioDetail = () => import('@/views/detail/AudioDetail.vue');
const ProgramDetail = () => import('@/views/ProgramDetail.vue');

const newsSource = import.meta.env.VITE_NEWS_SOURCE;
let topicType = import.meta.env.VITE_TOPIC_TYPE;
topicType = topicType || 1;
const homePage = {
  path: '/',
  name: 'index',
  meta: { keepAlive: true },
};
switch (newsSource) {
  case 'channel': {
    homePage.component = Channel;
    break;
  }
  case 'topic': {
    if (topicType === 1) {
      homePage.component = Topic;
    } else {
      homePage.component = Topic2;
    }
    break;
  }
  default: {
    homePage.component = Home;
    break;
  }
}

// 注册路由
const routes = [
  homePage,
  {
    path: '/childChannel', name: 'childChannel', component: childChannel, meta: { keepAlive: true },
  },
  { path: '/liveDetail', name: 'liveDetail', component: LiveDetail },
  { path: '/videoDetail', name: 'videoDetail', component: VideoDetail },
  { path: '/textDetail', name: 'textDetail', component: TextDetail },
  { path: '/imageDetail', name: 'imageDetail', component: ImageDetail },
  {
    path: '/topicDetail', name: 'topicDetail', component: TopicDetail, meta: { keepAlive: true },
  },
  {
    path: '/groupDetail', name: 'groupDetail', component: GroupDetail, meta: { keepAlive: true },
  },
  { path: '/audioDetail', name: 'audioDetail', component: AudioDetail },
  { path: '/ProgramDetail', name: 'programDetail', component: ProgramDetail },
];
// 创建路由实例并传递 `routes` 配置
const router = createRouter({
  // hash 模式
  history: createWebHashHistory(),
  routes,
});
export default router;
